import Swiper from 'swiper/bundle';

// BARCINO - Détail torréfacteur : swiper "tous les cafés" + lien d'ancrage
// Même mécanique que initCoffretsSwiper (barcino_home.js) — injection JS des
// classes swiper-wrapper/swiper-slide. Le swiper s'active :
//   - dès plus de 3 cartes (tous écrans), OU
//   - sur middle-screen (≤768px) quel que soit le nombre de cartes.
// En dehors de ces cas (≤3 cartes au-dessus de middle-screen), la grille reste
// statique (3 cartes en ligne). `data-products-swiper` est toujours posé côté
// PHP pour que le JS puisse cibler la grille dans tous les cas.
const PRODUCTS_SWIPER_MAX = 768; // middle-screen

const barcinoTorrefacteurDetail = {
    _productsSwiper: null,
    _onResize: null,
    _onScrollClick: null,

    init() {
        this.syncProductsSwiper();
        this.bindSeeAllProducts();

        this._onResize = () => this.syncProductsSwiper();
        window.addEventListener('resize', this._onResize, { passive: true });
    },

    syncProductsSwiper() {
        const el = document.querySelector('[data-products-swiper]');
        if (!el) return;

        const cards = Array.from(el.querySelectorAll('.bc-catalogue-card'));
        if (!cards.length) return;

        const shouldSwipe = cards.length > 3 || window.innerWidth <= PRODUCTS_SWIPER_MAX;

        if (shouldSwipe && !this._productsSwiper) {
            const wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            cards.forEach((card) => {
                card.classList.add('swiper-slide');
                wrapper.appendChild(card);
            });
            el.appendChild(wrapper);
            // --swiper : passe la grille en display:block (styles swiper) ; ajouté
            // ici pour couvrir le cas ≤3 cartes que le PHP ne marque pas.
            el.classList.add('swiper', 'bc-product-suggestions__grid--swiper');

            this._productsSwiper = new Swiper(el, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                grabCursor: true,
                a11y: { slideRole: '' },
                navigation: {
                    prevEl: document.querySelector('[data-products-previous]'),
                    nextEl: document.querySelector('[data-products-next]'),
                },
                breakpoints: {
                    600: { slidesPerView: 2.15, spaceBetween: 16 },
                    992: { slidesPerView: 3, spaceBetween: 16 },
                    1400: { slidesPerView: 4, spaceBetween: 16 },
                },
            });
        } else if (!shouldSwipe && this._productsSwiper) {
            this.destroyProductsSwiper();
        }
    },

    destroyProductsSwiper() {
        if (this._productsSwiper) {
            this._productsSwiper.destroy(true, true);
            this._productsSwiper = null;
        }

        const el = document.querySelector('[data-products-swiper]');
        if (!el) return;

        const wrapper = el.querySelector('.swiper-wrapper');
        if (wrapper) {
            Array.from(wrapper.children).forEach((card) => {
                card.classList.remove('swiper-slide');
                el.insertBefore(card, wrapper);
            });
            wrapper.remove();
        }
        el.classList.remove('swiper', 'swiper-initialized', 'bc-product-suggestions__grid--swiper');
    },

    bindSeeAllProducts() {
        this._onScrollClick = (event) => {
            const btn = event.target.closest('[data-scroll-products]');
            if (!btn) return;
            const target = document.querySelector('#torrefacteur-products');
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        document.addEventListener('click', this._onScrollClick);
    },

    destroy() {
        if (this._onResize) {
            window.removeEventListener('resize', this._onResize);
            this._onResize = null;
        }
        if (this._onScrollClick) {
            document.removeEventListener('click', this._onScrollClick);
            this._onScrollClick = null;
        }
        this.destroyProductsSwiper();
    },
};

export default barcinoTorrefacteurDetail;
